import { addendumRequestsTyped } from "@/api/(requests)/addendumTyped";
import type { CosignMetaBody, UUID } from "@/core/types";

export async function getNoteAddendumCosignDetails(addendumId: UUID): Promise<CosignMetaBody> {
  return addendumRequestsTyped.get_note_addendum_cosign_details({ urlParams: { addendumId } });
}
